/* eslint-disable react/forbid-prop-types,react/no-unused-prop-types,no-shadow */

import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import MomentTz from 'moment-timezone';
import _ from 'lodash';
import {
  toggleAssetPushToCloud,
  clearLogs,
  resetAssetPushToCloud,
  queryAssetPushToCloudLogs,
} from '../../../../state/assetPushToCloud';
import { isOwnerOfAsset } from '../../../../utils/assetDetails/isOwnerOfAsset';
import { selectIsUserVaultSuperAdmin, selectUserRole } from '../../../../state/user/userOrgRole';
import Warning from '../../Warning';
import { IAppState } from '../../../../state/reducers';
import { IProps, IDispatchProps, IStateProps } from './interfaces';
import { AccordionContainer, AccordionDetailsContainer } from './styles';

class AssetPushToCloud extends PureComponent<IProps, null> {
  private headCells: any[] = [];

  constructor(props: IProps) {
    super(props);

    this.headCells = [
      { id: 'orgName', label: 'Organization' },
      { id: 'actionDate', label: 'Time' },
    ];
  }

  handleToggle = () => {
    const {
      isOpen,
      rawAssetDetails,
      toggleAssetPushToCloud,
      queryAssetPushToCloudLogs,
      clearLogs,
    } = this.props;

    if (isOpen) {
      clearLogs();
      toggleAssetPushToCloud();
    } else {
      queryAssetPushToCloudLogs(rawAssetDetails._id, true);
    }
  };

  componentDidUpdate = (prevProps: IProps) => {
    const { resetAssetPushToCloud, rawAssetDetails } = this.props;

    if (!_.isEqual(rawAssetDetails, prevProps.rawAssetDetails)) {
      resetAssetPushToCloud();
    }
  };

  render() {
    const {
      rawAssetDetails,
      isOpen,
      logs,
      securityProfiles: { isLoaded, idValueMapping },
      userRole,
      isSuperAdmin,
    } = this.props;

    const isOwner = isLoaded ? isOwnerOfAsset(userRole, rawAssetDetails, idValueMapping) : false;

    if (!isOwner && !isSuperAdmin) {
      return null;
    }

    return (
      <>
        <AccordionContainer
          expanded={isOpen}
          onChange={this.handleToggle}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Asset Push To Cloud</Typography>
          </AccordionSummary>
          <AccordionDetailsContainer>
            <Warning
              isWarning={logs.length === 0}
              message="Pushes to cloud not found"
              fullWidth
            />
            {logs.length > 0 && (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {this.headCells.map((cell) => (
                        <TableCell
                          key={cell.id}
                          align="center"
                        >
                          {cell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logs.map((log) => (
                      <TableRow>
                        <TableCell align="center">
                          {log._source.orgName}
                        </TableCell>
                        <TableCell align="center">
                          {MomentTz.tz(log._source.actionDate, MomentTz.tz.guess()).format('L LT')}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </AccordionDetailsContainer>
        </AccordionContainer>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.assetPushToCloud.isOpen,
  logs: state.assetPushToCloud.logs,
  securityProfiles: state.securityProfiles,
  userRole: selectUserRole(state),
  isSuperAdmin: selectIsUserVaultSuperAdmin(state),
});

const mapDispatchToProps: IDispatchProps = {
  toggleAssetPushToCloud,
  clearLogs,
  resetAssetPushToCloud,
  queryAssetPushToCloudLogs,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetPushToCloud);
